import { Backdrop, CircularProgress } from '@mui/material'

interface LoadingProps {
  open?: boolean
  isAbsolutePos?: boolean
}

const Loading = ({ open = true, isAbsolutePos = false }: LoadingProps): JSX.Element => (
  <Backdrop
    className="loading-wrap"
    open={open}
    sx={{
      backgroundColor: (theme) => theme.palette.background.paper,
      zIndex: (theme) => theme.zIndex.drawer + 1,
      maxWidth: 'unset',
      ...(isAbsolutePos && {
        position: 'absolute',
      }),
    }}
  >
    {/* I messed up the color of the loader so that it doesn't pick up the color of the theme */}
    <CircularProgress sx={{ color: 'gray' }} />
  </Backdrop>
)

export default Loading
